// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_c6b84844","searchBarWrapper":"_45fc453b","categoryTile":"_53f51f13"};